module.exports = "/_next/static/images/boost-employee-wellness-622d2111f7c8b5c4b86722ae0e877664.svg";